import React, { useEffect } from 'react'
import Footer from '../components/Footer'
import { Col, Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { Link } from 'react-router-dom';

function LimitedOffer() {
  const navigate = useNavigate()
  // const storedUserType = localStorage.getItem("type");
  // const [credits, setCredits] = useState(10000);
  // const [couponCode, setCouponCode] = useState(' ');
  // const [pricePerCredit, setPricePerCredit] = useState(storedUserType === 'callcenter' ? 0.025 : 0.08);
  // const [totalPrice, setTotalPrice] = useState(storedUserType === 'callcenter' ? (10000 * 0.025).toFixed(2) : (10000 * 0.08).toFixed(2));
  // const [discount, setDiscount] = useState(0);
  // const [discountedPrice, setDiscountedPrice] = useState(totalPrice);
  // const apiKey = process.env.REACT_APP_API_KEY;
  const auth = getAuth();

  useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
          if (!user) {
              // If user is not authenticated, redirect to the sign-in page
              navigate('/sign-in');
          }
      });

      return () => unsubscribe(); // Cleanup the listener on component unmount
  }, [auth, navigate]);


  // const calculatePrice = (credits) => {
  //   let price = 0;
  //   if (storedUserType === "callcenter") {
  //     if (credits <= 9999) price = 0.03;
  //     else if (credits <= 19999) price = 0.025;
  //     else price = 0.025;
  //   } else {
  //     if (credits <= 9999) price = 0.085;
  //     else if (credits <= 19999) price = 0.08;
  //     else price = 0.07;
  //   }
  //   const total = (credits * price).toFixed(2);
  //   setPricePerCredit(price);
  //   setTotalPrice(total);
  //         setDiscountedPrice(0);
  //         setDiscount(0);

  //   // if (discount > 0) {
  //   //   setDiscountedPrice((total * (1 - discount / 100)).toFixed(2));
  //   // }
  // };

  // const handleCreditsChange = (e) => {
  //   const numericValue = parseInt(e.target.value, 10) || 0;
  //   setCredits(numericValue);
  //   calculatePrice(numericValue);
  // };

  // const handleApplyCoupon = async () => {
  //   if (couponCode.length>1) {
  //     try {
  //       const response = await axios.post('https://api.v2.spotYourLeads.com/payments/coupon', {
  //         couponCode: couponCode,
  //         userType: storedUserType,
  //         amount: credits
  //       }, {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'x-api-key': apiKey
  //         }
  //       });


  //       if (response.data.valid) {
  //         const discountValue = response.data.discount.includes('%')
  //           ? parseFloat(response.data.discount.replace('%', '')) / 100
  //           : parseFloat(response.data.discount.replace('$', ''));

  //         const newPrice = response.data.discount.includes('%')
  //           ? totalPrice * (1 - discountValue)
  //           : totalPrice - discountValue;

  //         setDiscount(discountValue * 100); 
  //         setDiscountedPrice(newPrice.toFixed(2)); 

  //         Swal.fire({
  //           icon: 'success',
  //           title: 'Coupon applied',
  //           text: `You received a ${response.data.discount} discount!`,
  //           customClass: {
  //             confirmButton: 'my-confirm-button',
  //           }
  //         });
  //       } else {
  //         setDiscount(0);
  //         setDiscountedPrice(totalPrice);
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Invalid Coupon',
  //           text: response.data.message,
  //           customClass: {
  //             confirmButton: 'my-confirm-button',
  //           }
  //         });

  //       }
  //     } catch (error) {
  //       Swal.fire({
  //         icon: 'error',
  //         title: error.response.data.message,
  //         customClass: {
  //           confirmButton: 'my-confirm-button',
  //         }
  //       });
  //     }
  //   }else{
  //     Swal.fire({
  //       icon: 'error',
  //       title: "Enter Valid Coupon",
  //       customClass: {
  //         confirmButton: 'my-confirm-button',
  //       }
  //     });
  //   }
  // };

  // const handleCompletePurchase = async () => {
  //   const uid = localStorage.getItem("uid");
  // //  if (credits && uid) {
  // //     try {

  // //       const data = {
  // //         price: discount > 0? discountedPrice : totalPrice,
  // //         credits: credits,
  // //         uid: uid,
  // //         ...(discount > 0 && { couponCode })
  // //       };
  // //       console.log(data);

  // //       navigate('/ContactPricing', { state: data });


  // //     } catch (error) {
  // //       Swal.fire({
  // //         icon: 'error',
  // //         title: 'Purchase failed',
  // //         text: error.response?.data?.message || 'An error occurred while processing your purchase.',
  // //         customClass: {
  // //           confirmButton: 'my-confirm-button',
  // //         }
  // //       });
  // //     }
  // //   } else {
  // //     Swal.fire({
  // //       icon: 'error',
  // //       title: 'Invalid Amount',
  // //       text: 'Please enter a valid amount of credits.',
  // //       customClass: {
  // //         confirmButton: 'my-confirm-button',
  // //       }
  // //     });
  // //   }

  //   if (credits && uid) {
  //     try {
  //       const payload = {
  //         amount: credits,
  //         uid: uid,
  //       };
  //       if (discount > 0) payload.couponCode = couponCode;

  //       const response = await axios.post("https://api.v2.spotYourLeads.com/payments/checkout", payload, {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'x-api-key': apiKey
  //         }
  //       });
  //       window.location.href = response.data.url;
  //     } catch (error) {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Purchase failed',
  //         text: error.response?.data?.message || 'An error occurred while processing your purchase.',
  //         customClass: {
  //           confirmButton: 'my-confirm-button',
  //         }
  //       });
  //     }
  //   } else {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Invalid Amount',
  //       text: 'Please enter a valid amount of credits.',
  //       customClass: {
  //         confirmButton: 'my-confirm-button',
  //       }
  //     });
  //   }
  // };
  // const CompletePurchase = async (value) => {
  //   const uid = localStorage.getItem("uid");

  //   // try {
  //   //   const data = {
  //   //     subscriptionType: value,
  //   //     uid: uid,
  //   //   };
  //   //   console.log(data);

  //   //   navigate('/ContactPricing', { state: data });

  //   // } catch (error) {
  //   //   Swal.fire({
  //   //     icon: 'error',
  //   //     title: 'Subscription Failed',
  //   //     text: error.response.data.message,
  //   //     customClass: {
  //   //       confirmButton: 'my-confirm-button',
  //   //     }
  //   //   });
  //   // }


  //   try {
  //     const payload = {
  //       subscriptionType: value,
  //       uid: uid,
  //     };
  //     const response = await axios.post("https://api.v2.spotYourLeads.com/payments/subscribe", payload, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'x-api-key': apiKey,
  //         customClass: {
  //           confirmButton: 'my-confirm-button',
  //         }
  //       }
  //     });

  //     window.location.href = response.data.url;
  //   } catch (error) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Subscription Failed',
  //       text: error.response.data.message,
  //       customClass: {
  //         confirmButton: 'my-confirm-button',
  //       }
  //     });
  //   }
  // };
  return (
    <>
      <Helmet>
        <title> Spot Your Leads |  Save on Verified Real Estate Leads </title>
      </Helmet>


        <section className="pricingSec3">
        <Container>

            <div className='pricing-title'>
              <h2>Limited Time Offer
                <br />
                “Discounted Leads”
              </h2>
              <h3>Introduction:</h3>
              <h5>"Exclusive Discounts on Verified Real Estate Leads!"</h5>
              <p>
              <span>
                Spot Your Leads </span> brings you limited-time offers on high-quality leads. These deals are
                designed to help you maximize your ROI while staying within budget. Act fast—these
                leads go quickly!
              </p>
            </div>
            <Row className='justify-content-center'>
  
              <Col md={4} sm={12}>
                <div className='yearly'>
                  <h3>50% <span> Off</span></h3>
                  <p>Vacant Lot Leads </p>

                  <h6>Limited Stock Remaining</h6>
                  <Link to="/leads-shop?type=discounted">
                  <button
                  >Claim the Deal</button>
                  </Link>
                </div>
              </Col>
              <Col md={4} sm={12}>
                <div className='yearly'>
                  <h4>
                  Bundle Deals:
                  <br />
                  Buy 5 Leads
                  </h4>
                  <br />
                  <br />

                  <h3> Get 1 Free!</h3>
                  <br />

              
                </div>
              </Col>
            </Row>
            <h5>Don’t Miss Out—<span>Browse Our Discounted Leads Now.</span>
            </h5>
          </Container>
        </section>
  
      <Footer />
    </>
  )
}

export default LimitedOffer
